// backoffice/src/pages/planning/PublicHolidayFormModal.js

import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
// Importer TOUS les thunks nécessaires
import { createPublicHoliday, updatePublicHoliday, fetchPublicHolidays } from '../../redux/slices/planning/planningThunks';
import dayjs from 'dayjs';

const dateFormat = 'YYYY-MM-DD';

function PublicHolidayFormModal({ visible, onCancel, holiday }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const isEditing = !!holiday;

  // Pré-remplir (inchangé)
  useEffect(() => {
    if (visible) {
        if (isEditing && holiday) {
          form.setFieldsValue({
            name: holiday.name,
            date: holiday.date ? dayjs(holiday.date, dateFormat) : null, // Gérer date null/invalide
          });
        } else {
          form.resetFields();
        }
    }
  }, [holiday, form, isEditing, visible]);

  // Soumission formulaire
  const handleOk = () => {
    form.validateFields()
      .then((values) => {
        setLoading(true);
        const dataToSend = {
          name: values.name,
          date: values.date.format(dateFormat),
        };

        const action = isEditing
          ? dispatch(updatePublicHoliday({ id: holiday.id, ...dataToSend }))
          : dispatch(createPublicHoliday(dataToSend));

        action.unwrap()
          .then(() => {
            message.success(`Jour férié ${isEditing ? 'mis à jour' : 'créé'}!`);
            onCancel();
            // --- RECHARGER LA LISTE COMPLÈTE ---
            console.log("Dispatching fetchPublicHolidays after CUD operation");
            dispatch(fetchPublicHolidays()); // <-- AJOUT IMPORTANT
            // ------------------------------------
          })
          .catch((err) => { console.error('Erreur formulaire jour férié:', err); })
          .finally(() => { setLoading(false); });
      })
      .catch((info) => { console.log('Erreur validation formulaire:', info); });
  };

  return (
    <Modal
      title={isEditing ? 'Modifier le Jour Férié' : 'Ajouter un Jour Férié'}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      footer={[
         <Button key="back" onClick={onCancel}> Annuler </Button>,
         <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
            {isEditing ? 'Mettre à jour' : 'Créer'}
         </Button>,
       ]}
    >
      <Form form={form} layout="vertical" name="holiday_form">
        <Form.Item
          name="name"
          label="Nom du Jour Férié"
          rules={[{ required: true, message: 'Veuillez entrer le nom !' }]}
        >
          <Input placeholder="Ex: Fête Nationale" />
        </Form.Item>
        <Form.Item
          name="date"
          label="Date"
          rules={[{ required: true, message: 'Veuillez sélectionner la date !' }]}
        >
          <DatePicker format={dateFormat} style={{ width: '100%' }} placeholder="Sélectionner la date" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PublicHolidayFormModal;